module.exports = __webpack_public_path__ + "static/media/China.27fdb822.png";